import React from 'react';
import PropTypes from 'prop-types';
import { Components, Utils, translate } from 'versafleet-core';
import { connect } from 'react-redux';
import ReduxActions from 'reduxActions';
import Edit from '../edit';

class MobileJobEditForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      form: this._getDefaultForm(this.props.data),
      error: {},
      isChanged: false,
      showCloseModal: false,
    };
  }

  UNSAFE_componentWillMount() {
    Utils.FullScreenLoading.FullScreenLoadingManager.open(this.props.strings.Job.page.loadingItem);
    this.props.dispatch(ReduxActions.job.fetch(Utils.Router.getParams().id))
      .then(() => {
        this.props.dispatch(ReduxActions.constant.fetchList());
      })
      .then(() => {
        Utils.FullScreenLoading.FullScreenLoadingManager.close();
      });
  }

  _getDefaultForm(data = {}) {
    const baseTask = data.base_task || {};

    return {
      job_type: data.job_type || 'delivery',
      base_task_attributes: {
        billing_account_id: baseTask.billing_account_id
          || (baseTask.billing_account && baseTask.billing_account.id),
        address_attributes: this._getDefaultAddress(baseTask.address || {}),
        time_type: baseTask.time_type,
        time_from: baseTask.time_from,
        time_to: baseTask.time_to,
        time_window_id: Utils.Helper.isNullOrUndefined(baseTask.time_window)
          ? baseTask.time_window_id : baseTask.time_window.id,
      },
      tag_list: Utils.Helper.isNullOrUndefined(data.tags) ? []
        : data.tags.map(tag => tag.name).filter(tag => tag !== 'Point-to-Point'),
      remarks: data.remarks,
      attachments_attributes: this._getAttachmentsDefaultForm(data),
    };
  }

  _getAttachmentsDefaultForm = (data) => {
    const attachments = data.attachments || [];
    return attachments.map(attachment => ({
      id: attachment.id,
      name: attachment.name,
      url: attachment.url,
    }));
  }

  _getDefaultAddress = address => ({
    name: address.name || null,
    line_1: address.line_1 || null,
    line_2: address.line_2 || null,
    city: address.city || null,
    country: address.country || null,
    zip: address.zip || null,
    contact_person: address.contact_person || null,
    contact_number: address.contact_number || null,
    email: address.email || null,
  });

  _isPointToPoint = (data) => {
    const p2p = data.job_type === 'p2p';
    return p2p || (data.job_type === 'delivery' && data.tags && data.tags.filter(tag => tag.name === 'Point-to-Point').length > 0);
  }

  _onFormChange = (fieldName, value) => {
    let form;
    if (!this.state.isChanged) {
      this.setState({ isChanged: true });
    }
    if (fieldName === 'customer_id') {
      if (value !== '') {
        this.props.dispatch(ReduxActions.customer.fetch(value));
      }
      form = {
        ...this.state.form,
        customer_id: value === '' ? null : value,
        base_task_attributes: {
          ...this.state.form.base_task_attributes,
          billing_account_id: null,
        },
      };
      this.setState({ form });
    } else if (fieldName === 'job_type' && value !== 'p2p') {
      form = {
        ...this.state.form,
        job_type: value,
        base_task_attributes: {
          ...this.state.form.base_task_attributes,
          billing_account_id: null,
        },
      };
      this.setState({ form });
    } else if (fieldName === 'base_task_attributes.billing_account_id') {
      if (value && !value === '') {
        this.props.dispatch(ReduxActions.billingAccount.fetch(value));
      }
      form = {
        ...this.state.form,
        base_task_attributes: {
          ...this.state.form.base_task_attributes,
          billing_account_id: value,
        },
      };
      this.setState({ form });
    } else {
      this.setState(prevState => ({
        form: Utils.Helper.setFilter(prevState.form, fieldName, value),
      }));
    }
  }

  _save = () => {
    let form = this.state.form;
    if (this._isPointToPoint(this.props.data)) {
      form = {
        ...this.state.form,
        tag_list: this.state.form.tag_list.concat(['Point-to-Point']),
      };
    }

    Utils.FullScreenLoading.FullScreenLoadingManager.open(this.props.strings.Job.form.saving);
    this.props.dispatch(ReduxActions.job.update(this.props.data.id, form))
      .then(() => {
        Utils.Router.transitionFromSubpath('jobs', Utils.Router.getParams().id);
      })
      .catch((error) => {
        this.setState({ error });
      })
      .then(() => {
        Utils.FullScreenLoading.FullScreenLoadingManager.close();
      });
  }

  _renderNavBar() {
    const data = this.props.data || {};

    return (
      <Components.Mobile.NavigationBar
        leftButton={Components.Mobile.NavigationBar.buttonConst.CLOSE}
        onLeftButtonClick={() => {
          if (this.state.isChanged) {
            this.setState({ showCloseModal: true });
          } else {
            Utils.Router.transitionTo('/jobs');
          }
        }}
        title={`Job ${data.job_type === 'pickup' ? 'pickup' : 'delivery'} info`}
      />
    );
  }

  _renderButton() {
    return (
      <Components.Form.MobileMainButton
        iconClassName="versa-completed"
        id="vf-mobile-job__edit-form__save-button"
        onClick={this._save}
      >
        {this.props.strings.Job.form.buttons.save}
      </Components.Form.MobileMainButton>
    );
  }

  render() {
    if (Utils.Helper.isNullOrUndefined(this.props.data)) {
      return false;
    }

    return (
      <Components.Form.MobileCoreLayout
        className="vf-job__mobile-edit-form"
        footer={this._renderButton()}
        header={this._renderNavBar()}
      >
        <Edit
          constant={this.props.constant}
          customer={this.props.customer}
          data={this.props.data}
          error={this.state.error}
          form={this.state.form}
          id="vf-mobile-job__edit-form"
          onFormChange={this._onFormChange}
          optionAddresses={this.props.optionAddresses}
        />
        <Components.Form.CloseConfirmationDialog
          leftButtonOnClick={() => Utils.Router.transitionTo('/jobs')}
          rightButtonOnClick={() => this.setState({ showCloseModal: false })}
          visible={this.state.showCloseModal}
        />
      </Components.Form.MobileCoreLayout>
    );
  }
}

MobileJobEditForm.propTypes = {
  constant: PropTypes.shape().isRequired,
  customer: PropTypes.shape({}).isRequired,
  data: PropTypes.shape({
    id: PropTypes.number,
    base_task: PropTypes.shape(),
    job_type: PropTypes.string,
    tags: PropTypes.arrayOf(PropTypes.string),
    remarks: PropTypes.string,
    tasks: PropTypes.arrayOf(PropTypes.shape()),
    attachments: PropTypes.arrayOf(PropTypes.shape()),
    address: PropTypes.shape(),
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
  optionAddresses: PropTypes.arrayOf(PropTypes.shape()),
  strings: PropTypes.shape({
    Job: PropTypes.shape({
      page: PropTypes.shape({
        loadingItem: PropTypes.string,
      }),
      form: PropTypes.shape({
        saving: PropTypes.string,
        buttons: PropTypes.shape({
          save: PropTypes.string,
        }),
      }),
    }),
  }).isRequired,
};

MobileJobEditForm.defaultProps = {
  optionAddresses: [],
};

const mapStateToProps = (state) => {
  const { job, profile, constant } = state;
  return {
    data: job.jobs[Utils.Router.getParams().id],
    constant: constant.constant,
    customer: profile.profile,
    optionAddresses: [],
    isUpdating: job.isUpdating,
  };
};

export default connect(mapStateToProps)(translate('')(MobileJobEditForm));
